"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SlideBarSprite = void 0;
const Sprite2d_1 = require("../../Common/Sprite2d");
const inversify_1 = require("inversify");
const SymbolClasses_1 = require("../../Utils/SymbolClasses");
const Utils_1 = require("../../Utils/Utils");
const Constants_1 = require("../../Core/Constants");
const Projection_1 = require("../../Core/Projection");
const pixi_js_1 = require("pixi.js");
let SlideBarSprite = class SlideBarSprite extends Sprite2d_1.Sprite2d {
    constructor(resources, helper) {
        var _a;
        super((_a = resources.game.textures) === null || _a === void 0 ? void 0 : _a.slide_bar);
        this.helper = helper;
        this.shouldRemove = false;
        this.anchor.set(0.5, 1);
        this.visible = false;
    }
    applyInfo(bar) {
        this.bar = bar;
        this.visible = true;
        this.shouldRemove = false;
    }
    update(musicTime) {
        if (!this.visible || this.shouldRemove || !this.bar)
            return;
        let st = this.bar.start.time;
        if (st < musicTime && this.bar.start.parent.pointerId)
            st = musicTime;
        let et = this.bar.end.time;
        if (et > musicTime + this.helper.staytime)
            et = musicTime + this.helper.staytime;
        if (this.bar.end.judge ||
            this.bar.start.judge === "miss" ||
            st >= et ||
            musicTime > this.bar.end.time + 1 ||
            (!this.bar.start.parent.pointerId && musicTime > this.bar.start.time + 1)) {
            this.shouldRemove = true;
            this.visible = false;
            this.zIndex = 0;
            return;
        }
        const startPos = Utils_1.ratio(this.bar.start.time, this.bar.end.time, st, Constants_1.LaneCenterXs[this.bar.start.lane], Constants_1.LaneCenterXs[this.bar.end.lane]);
        const startT = (musicTime - st) / this.helper.staytime;
        const sp = Projection_1.projection(startT, startPos);
        const endPos = Utils_1.ratio(this.bar.start.time, this.bar.end.time, et, Constants_1.LaneCenterXs[this.bar.start.lane], Constants_1.LaneCenterXs[this.bar.end.lane]);
        const endT = (musicTime - et) / this.helper.staytime;
        const ep = Projection_1.projection(endT, endPos);
        const f = sp.scale / ep.scale;
        const sx = (this.helper.noteScale * sp.scale) / SymbolClasses_1.NoteHelper.noteInitScale;
        const sy = ((sp.y - ep.y) / this.texture.height) * f;
        this.transform.setFromMatrix(new pixi_js_1.Matrix(sx, 0, ((ep.x - sp.x) / (ep.y - sp.y)) * sy, sy, sp.x, sp.y));
        this.projectionY = 1 - f;
        this.zIndex = sp.scale;
    }
};
SlideBarSprite = __decorate([
    inversify_1.injectable(),
    __metadata("design:paramtypes", [SymbolClasses_1.Resources, SymbolClasses_1.NoteHelper])
], SlideBarSprite);
exports.SlideBarSprite = SlideBarSprite;
//# sourceMappingURL=SlideBarSprite.js.map